export default __webpack_public_path__ + "resources/icons/d122-9c50.png";